<template>
  <!-- 一键提交 -->
  <div>

    <!-- <div v-if="!errorObj.firstBuildingType && errorObj.secondBuildingType" class="error-box">请选择二级业态</div> -->

	<div class="form-item-row" :class="{'error-border':errorObj.contacts}">
	  <div class="ad-title"><span class="must-ad">*</span>联系人</div>
	  <div class="value"><input @input="errorObj.contacts = false" type="text" v-model="form.contacts" maxlength="30"
	      placeholder="请输入联系人姓名"></div>
	</div>
	<div v-if="errorObj.contacts" class="error-box">请输入联系人姓名</div>

    <div class="form-item-row" :class="{'error-border':errorObj.mobile}">
      <div class="ad-title"><span class="must-ad">*</span>联系方式</div>
      <div class="value"><input @input="errorObj.mobile = false" type="text" v-model="form.mobile" maxlength="30"
          placeholder="请输入手机号"></div>
    </div>
    <div v-if="errorObj.mobile" class="error-box">请输入手机号</div>

    <div class="form-item-row f-column" :class="{'error-border':errorObj.firstBuildingType || errorObj.secondBuildingType}">
      <div class="flex-box">
        <div class="ad-title"><span class="must-ad">*</span>项目业态</div>
        <div class="value">
          <input type="text" v-model="selectedFirstType.name" placeholder="请选择项目业态" @click="showFirst = true"
            readonly="readonly">
          <img class="arrow-btn"
            src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png"
            alt="">
          <van-popup v-model="showFirst" position="bottom">
            <van-picker show-toolbar @cancel="showFirst = false" :columns="firstTypeList" @confirm="firstType"
              :value-key="'name'" :title="'请选择一级业态'" />
          </van-popup>
        </div>
      </div>
      <div style="border-top:1px solid rgba(0,0,0,.12)" class="flex-box" v-if="selectedFirstType.name ">
        <div class="ad-title"></div>
        <div class="value">
          <input type="text" v-model="selectedSecondType.name" placeholder="请选择二级业态" @click="showSecond = true"
            readonly="readonly">
          <img class="arrow-btn"
            src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png"
            alt="">
          <van-popup v-model="showSecond" position="bottom">
            <van-picker show-toolbar @cancel="showSecond = false" :columns="secondTypeList" @confirm="secondType"
              :value-key="'name'" :title="'请选择二级业态'" />
          </van-popup>
        </div>
      </div>
    </div>
    <div v-if="errorObj.firstBuildingType" class="error-box">请选择一级业态</div>
    <div v-if="errorObj.secondBuildingType" class="error-box">请选择二级业态</div>

    <div class="form-item-row f-column" :class="{'error-border':errorObj.projectStage}">
      <div class="ad-title width-100"><span class="must-ad">*</span>项目阶段</div>
      <div class="checkbox-row">
        <div class="checkbox-row-item" :class="{active : form.projectStage === '1'}" @click="radioChange('1')">
          <div>方案设计</div>
        </div>
        <div class="checkbox-row-item" :class="{active : form.projectStage === '2'}" @click="radioChange('2')">
          <div>施工图</div>
        </div>
        <div class="checkbox-row-item" :class="{active : form.projectStage === '3'}" @click="radioChange('3')">
          <div>深化设计</div>
        </div>
        <div class="checkbox-row-item" :class="{active : form.projectStage === '4'}" @click="radioChange('4')">
          <div>初步设计</div>
        </div>
      </div>
    </div>
    <div v-if="errorObj.projectStage" class="error-box">请选择项目阶段</div>

    <div class="form-item-row f-column" :class="{'error-border':errorObj.putTypeArr}">
      <div class="ad-title width-100"><span class="must-ad">*</span>交付产品</div>
      <van-checkbox-group class="checkbox-row padding-b-16" v-model="putTypeArr" @change="errorObj.putTypeArr = false">
        <van-checkbox v-for="item in list" :key="item.id" :name="item.id"  shape="square" checked-color="#2F7BFF" icon-size="18px">
          <span style="padding-right: 20px;">{{item.name}}</span>
        </van-checkbox>
      </van-checkbox-group>
    </div>
    <div v-if="errorObj.putTypeArr" class="error-box">请选择交付产品</div>

    <div class="form-item-row f-column syetem" v-if="selectedFirstType.name">
      <div class="ad-title width-100"><span class="must-ad">*</span>系统选择</div>
      <div :class="[show ? 'active' :'']">
        <van-checkbox-group class="checkbox-row padding-b-16" v-model="sysAttr" @change="errorObj.sysAttr = false">
          <van-checkbox v-for="item in selectedSystem " :key="item.id" :name="item.id"  shape="square" checked-color="#2F7BFF" icon-size="18px">
           {{item.name}}
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="show-box" @click="change()">
        <van-icon name="arrow-down" v-if="show"/>
        <van-icon name="arrow-up" v-if="!show"/>
        {{show?'查看更多系统':'收起全部系统'}}
      </div>
    </div>
    <div class="form-item-row"  :class="{'error-border':errorObj.sysAttr}">
    </div>
    <div v-if="errorObj.sysAttr" class="error-box" >请选择系统</div>


    <div class="form-item-row f-column remark">
      <div class="ad-title width-100">备注</div>
      <textarea v-model="form.description" maxlength="200" placeholder=""></textarea>
      <div class="textarea-length"><span style="color:rgba(0,0,0,.85)">{{form.description.length}}</span>/200</div>
    </div>
    <div class="h12"></div>
    <div class="filw">
      <div class="form-item-row fileList">
        <van-uploader
          :before-read="beforeRead"
          upload-icon="../../../assets/images/activities/desiagner/hezuo.png"
          accept="*"
          :after-read="uploadfn"
          :max-size="100*1024*1024"
          :max-count="9"
        >
        <div style="width: 100%; display: flex;justify-content: space-between;">
          <div class="fileLink-left">
            <img src="../assets/images/file-link.png">
            <span>上传附件</span>
          </div>
          <van-button icon="none" type="default">上传文件</van-button>
        </div>
        <!-- <van-uploader accept="*" v-model="fileList" :after-read="beforeRead"  icon="plus"  :after-read="afterRead" > -->
        </van-uploader>
      </div>
      <div class="wrapper">
        <div class="van-uploader__wrapper">
          <div class="van-uploader__preview" v-for="(item,index) in fileLists" :key="index">
            <div class="van-uploader__file">
              <i class="van-icon van-icon-description van-uploader__file-icon"</i>
              <div class="van-uploader__file-name van-ellipsis">{{item.fileName}}</div>
            </div>
            <div class="van-uploader__preview-delete" @click="deleted(item)">
              <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i></div>
            </div>
        </div>
      </div>
      <p class="infor">doc\docx\xls\xlsx\ppt\pptx\pdf\zip\dwg\rar\格式电子文档，单个文件不超过100M。</p>
    </div>
    <div class="form-item-button">
      <div><button @click="submitDemand">确认提交</button></div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import headers from '@/components/headers'
  import dateTimePlug from '@/components/datetime'
  import { replaceURL } from '@/api/brand/utils'
  import { getAdvertising } from '@/api/common'
  import {  queryFirstType, querySecondType, querySystemType, queryProvince } from '@/api/demands/demand'
  import { Row, Col, Checkbox, CheckboxGroup, RadioGroup, Radio,Toast, Notify, Popup, Picker} from 'vant'
  import {  mapState } from 'vuex'
  import { getCookie } from '@/utils/cookies'
  import { toLogin } from '@/utils/common'
  export default {
    name: 'add-demand-form',
    components: {
      Row,
      Col,
      Checkbox,
      CheckboxGroup,
      RadioGroup,
      dateTimePlug,
      Radio,
      Toast,
      Notify,
      headers,
    },
    computed: {
      ...mapState({
        API2DomainUrl: state => state.baseData.API2DomainUrl,
        token: state => state.user.ticket,
        userId: state => state.user.AccountId,
        userName: state => state.user.AccountName
      })
    },
    data() {
      return {
        show:true,
        showPicker: true,
        hraderP: {
          title: '提交需求',
          lefticon: true
        },
        nimeColor: true,
        radio: '',
        list: [{
          id: 4,
          name: '标书'
        }, {
          id: 1,
          name: '方案'
        }, {
          id: 3,
          name: '图纸'
        }, {
          id: 2,
          name: '报价清单'
        }],
        result: [],
        form: {
          contacts:'',//联系人
          mobile: '', // 手机号
          description: '', // 备注
          projectStage: '', //  项目阶段 1.规范设计，2投标设计 3深化设计 0其他
          putType: '', // 交付产品  1方案，2 报价清单，3图纸 4标书-->逗号分割
          firstBuildingType: '', // 一级业态
          secondBuildingType: '', // 二级业态
          sysAttr: '', // 系统
          attachment:'',//附件
          userId:0
        },
        fileKey: 1,
        attachmentsList:[],
        errorObj: {
          contacts:false,
          mobile: false,
          firstBuildingType: false,
          secondBuildingType: false,
          projectStage: false,
          sysAttr: false,
          putTypeArr: false
        },
        putTypeArr: [],
        sysAttr:[],
        firstTypeList: [],
        secondTypeList: [],
        systemList: [],
        provinceList: [],
        cityList: [],
        showFirst: false,
        showSecond: false,
        showSystem: false,
        showProvince: false,
        showCity: false,
        selectedFirstType: {},
        selectedSecondType: {},
        selectedSystem: [],
        selectedProvince: {},
        selectedCity: {},
        areaColumns: [],
        fileLists:[],
        // 限制格式
        geshi: [
          'doc',
          'docx',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
          'pdf',
          'zip',
          'dwg',
          'rar'
        ],
        fromParam: null  
      }
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.fromParam = urlParams.get('from');
    },
    created() {
      // this.$store.dispatch('USER_GET_INFO')
      // if (this.getterCache('DEMAND_FORM_CACHE')) {
      //   this.form = JSON.parse(this.getterCache('DEMAND_FORM_CACHE'))
      //   this.clearCache('DEMAND_FORM_CACHE')
      // }
      if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
        toLogin()
        return
      }
      if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
        toLogin()
        return
      }

      this.form.userId = getCookie('accountId') || getCookie('AccountId')
      console.log(this.form.userId,'this.form.userId');
      this.getFirstType()
      this.getSystemType()
    },
    methods: {
      // 返回布尔值
      beforeRead (file) {
        console.log(file,'file');
        let index = file.name.lastIndexOf('.')
        let fileName = file.name.substring(index + 1, file.name.length)
        let status = this.geshi.findIndex((item) => item === fileName)
        let size = file.size
        if (status < 0) {
          this.$toast('请上传符合格式的文件')
          return false
        }
        if (size > 100 * 1024 * 1024) {
          this.$toast('请上传30M以下的文件')
          return false
        }
        if(this.fileLists.length + 1>9){
          this.$toast('文件上传最多9个文件')
          return false
        }
        return true
      },
      deleted(item){
       var index = this.fileLists.indexOf(item);
       this.fileLists.splice(index, 1);
      },
      // 上传的方法
      uploadfn (file) {
        file.status = 'uploading'
        file.message = '上传中...'
        file.id = this.fileKey
        this.fileKey++
        fetch(
          '/platformApi/OSS/sign/project-homedo/shanghai'
        ).then((response) => {
          console.log(response)
          return response.json().then((data) => {
          console.log(data)
            const key = data.dir + data.key + '_${filename}'
            const ossData = new FormData()
            ossData.append('Filename', '${filename}')
            ossData.append('key', key)
            ossData.append('policy', data.policy)
            ossData.append('OSSAccessKeyId', data.OSSAccessKeyId)
            ossData.append('success_action_status', 200)
            ossData.append('signature', data.signature)
            ossData.append('file', file.file, replaceURL(file.file.name))
            axios
              .post(data.host, ossData, { timeout: 300000 })
              .then((res) => {
                const obj = {
                  fileName: replaceURL(file.file.name),
                  fileUrl: `${data.host}/${key.replace(
                    '${filename}',
                    replaceURL(file.file.name)
                  )}`
                }
                console.log(obj,'');
                console.log(222222222222222);
                 console.log(this.fileLists.length,'this.fileLists.length111111');
                this.fileLists.push(obj)
              })
          })
        })
      },
      changeCity(picker, values, index) {
        const checckObj = values[index]
        if (index === 0) {
          this.getCity(checckObj.value)
        }
      },
      change(){
        this.show = !this.show
      },
      firstType(data) {
        this.errorObj.firstBuildingType = false
        this.showFirst = false
        this.form.firstBuildingType = data.id
        this.selectedFirstType = data
        this.selectedSecondType = []
        this.selectedSystem = []
        this.form.secondBuildingType = ''
        this.form.sysAttr = ''
        this.getSecondType()
        this.getSystemType()
      },
      secondType(data) {
        this.errorObj.secondBuildingType = false
        this.showSecond = false
        this.form.secondBuildingType = data.id
        this.selectedSecondType = data
      },
      systemType(data) {
        this.errorObj.sysAttr = false
        this.showSystem = false
        this.selectedSystem = data
        var systemArr = data.map(item => {
          return item.id
        })
        this.form.sysAttr = systemArr.join(',')
      },
      // 获取一级业态列表
      getFirstType() {
        queryFirstType()
          .then(result => {
            if (result.status === 200 && result.data && result.data.data) {
              this.firstTypeList = result.data.data.requireTypeSysDataList
            }
          })
          .catch(err => {
            console.log(err)
            // ignore
          })
      },
      // 获取二级业态列表
      getSecondType() {
        let params = {
          parentId: this.form.firstBuildingType
        }
        querySecondType(params)
          .then(result => {
            if (result.status === 200 && result.data && result.data.data) {
              this.secondTypeList = result.data.data.requireTypeSysDataList
            }
          })
          .catch(err => {
            console.log(err)
            // ignore
          })
      },
      // 获取系统列表
      getSystemType() {
        let params = {
          typeId: this.form.firstBuildingType
        }
        querySystemType(params)
          .then(result => {
            if (result.status === 200 && result.data && result.data.data) {
              this.selectedSystem = result.data.data.requireTypeSysDataList
              console.log(this.selectedSystem,'this.systemList');
            }
          })
      },
      radioChange(item) {
        this.errorObj.projectStage = false
        this.form.projectStage = item
      },
      submitDemand() {
        this.form.attachment = this.fileLists.join(',')
        let attachment = [];
        this.fileLists.map(item => {
          attachment.push(item.fileUrl)
        })
        this.form.attachment = attachment.join(',')
        this.form.userName = this.userName
        this.form.source = 4
        this.form.putType = this.putTypeArr && this.putTypeArr.join(',')
        this.form.sysAttr = this.sysAttr && this.sysAttr.join(',')

        if (this.$route.query.source === 'srv') {
          this.form.source = 6
        }

        let flag = true

        // 手机号
        if (!this.form.contacts || this.form.contacts === '') {
          this.errorObj.contacts = true
          flag = false
        }

        // 项目业态
        if (!this.form.firstBuildingType || this.form.firstBuildingType === '') {
          this.errorObj.firstBuildingType = true
          flag = false
        } else {
          if (!this.form.secondBuildingType || this.form.secondBuildingType === '') {
            this.errorObj.secondBuildingType = true
            flag = false
          }
          if (!this.form.sysAttr || this.form.sysAttr === '') {
            this.errorObj.sysAttr = true
           flag = false
          }
        }
        // 方案设计
        if (!this.form.projectStage || this.form.projectStage === '') {
          this.errorObj.projectStage = true
          flag = false
        }
        // 手机号
        if (!this.form.mobile || this.form.mobile === '') {
          this.errorObj.mobile = true
          flag = false
        }
        if(this.form.mobile){
          const reg = /^(((0\d{2,3}-|0\d{2,4})\d{7,8})|(1[34578]\d{9})|(400-[0-9]{0,7}-[0-9]{1,7}))$/
          if (!reg.test(this.form.mobile)) {

            console.log(1111111);
            Toast('请输入正确的联系电话')
            flag = false
          }

        }
        // 交付产品
        if (this.putTypeArr.length <= 0) {
          console.log(this.putTypeArr.length);
          this.errorObj.putTypeArr = true
          flag = false
        }

        if(flag){
          this.$store.dispatch('DEMAND_ADD_CUSTOMIZED', {
            ...this.form,
            versionnub: this.$route.query.versionnub ? this.$route.query.versionnub : 1
          }).then(result => {
            if (result.status === 200 && result.data && result.data.code === 200) {
              this.getKeTuo()
              Toast('需求提交成功')
              setTimeout(() => {
                if (this.fromParam === 'solution') {
                  this.$router.replace('/demand/success.html?from=solution')
                } else {
                  this.$router.replace('/demand/success.html')
                }
              }, 2000)
            }
          })
        }
      },
      async getKeTuo() {
        var ticket = $HMD$.Cookie('ticket')
        const URL = 'https://common-api.' + $HMD$.rApi.S + 'homedo.com'
        // 其他活动请求path
        const NORMAL_PATH = `/bff-common-api/solicitationFor/sendEmail?type=4`
        const result = await axios({
          method: 'get',
          url: URL + NORMAL_PATH,
          headers: {
            ticket: ticket
          }
        })
        if (result.respCode === '0000') {
          console.log(result.respDesc);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-item-row {
    display: flex;
    align-items: center;
    width: 344px;
    margin: 0 auto;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    &.error-border {
      border-bottom: 1px solid #FF3030;
    }

    &.f-column {
      flex-direction: column;
    }

    .time-z-tips {
      margin-right: 14px;
    }

    .time-pr {
      color: rgba(0, 0, 0, 0.25);
    }

    .check-arrow-btn {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: 16px;
      right: 4px;
      font-size: 20px;
      pointer-events: none;
    }

    .item-limit {
      display: inline-block;
      width: 28%;
      height: 100%;
      color: #409EFF;
      font-size: 14px;
    }

    .sys-flex-box {
      display: flex;
      width: 100%;
      position: relative;
      align-items: center;
      padding-bottom: 16px;
    }

    .item-box {
      width: 72%;
      height: 24px;
      background-color: #ffffff;
      overflow: hidden;

      .system {
        display: inline-block;
        color: #2F7BFF;
        border: 1px solid #2F7BFF;
        background: rgba(47, 123, 255, 0.1);
        border-radius: 4px;
        padding: 0 4px;
        height: 24px;
        line-height: 22px;
        margin: 0 8px 12px 0;
        box-sizing: border-box;
      }

    }
  }

  .flex-box {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .width-100 {
    width: 100% !important;
  }
  .remark{
    padding: 0 23px;
    width: 100%;
    box-sizing: border-box;
    border: none;
  }
  .form-item {
    &-banner {
      img {
        vertical-align: middle;
        width: 100%;
      }
    }

    &-row {
      .ad-title {
        background-color: #FFF;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        color: #000000;
        width: 85px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        line-height: 1;

        .must-ad {
          color: #FF0000;
          padding-top: 4px;
          display: block;
          margin-right: 4px;
          font-size: 16px;
        }
      }

      .value {
        flex: 1;
        height: 50px;
        line-height: 50px;
        position: relative;

        input {
          width: 100%;
          font-size: 14px;
          border: none;
        }
      }

      textarea {
        width: 100%;
        height: 73px;
        font-size: 16px;
        border: none;
        resize: none;
        vertical-align: middle;
        background: #F8F9FB;
        padding-top: 10px;
        text-indent: 10px;
      }

      .textarea-length {
        font-size: 13px;
        text-align: right;
        width: 100%;
        line-height: 1;
        padding: 16px 0;
        color: rgba(0, 0, 0, .25);
        background: #F8F9FB;
        padding-right: 12px;
        box-sizing: border-box;
      }

      .checkbox-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        color: rgba(0, 0, 0, 0.45);
        font-size: 15px;

        &-item {
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          width: 80px;
          height: 24px;
          line-height: 22px;
          box-sizing: border-box;
          margin-right: 8px;
          margin-bottom: 16px;
          border: 1px solid rgba(0, 0, 0, 0.25);
          border-radius: 5px;

          &.active {
            border: 1px solid #2f7bff;
            color: #2F7BFF;
            background: rgba(47, 123, 255, 0.10);
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .check-all-item {
          height: 24px;
          padding-bottom: 16px;
          margin-right: 20px;
          font-size: 15px;
          color: rgba(0, 0, 0, 0.85);
          display: flex;
          align-items: center;

          div {
            margin-left: 8px;
          }

          &:nth-of-type(4n) {
            margin-right: 0;
          }
        }
      }

      .checkbox-row-item-more:last-child .check-all-item {
        margin-right: 0;
      }
    }

    &-button {
      width: 344px;
      margin: 16px auto 0;

      button {
        width: 100%;
        border: none;
        height: 44px;
        background-color: #2f7bff;
        border-radius: 8px;
        font-size: 18px;
        color: #FFF;
      }
    }
  }

  .line-item {
    height: 1px;
    width: 100%;
    background-color: #e5e5e5;
    border: 0;
  }

  .company-item {
    position: absolute;
    right: 10px;
  }

  .arrow-span {
    position: relative;
  }

  .arrow-btn {
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 12px;
    right: 4px;
    font-size: 20px;
    pointer-events: none;
  }

  .input-second {
    padding-left: 0;
    padding-right: 0;

  }

  .padding-b-16 {
    padding-bottom: 16px;
  }

  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: rgba(0, 0, 0, .25)
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(0, 0, 0, .25)
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(0, 0, 0, .25)
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(0, 0, 0, .25)
  }

  .check-img-icon {
    width: 20px;
    height: 20px
  }

  .error-box {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #FF3030;
    width: 343px;
    margin: 0 auto;
  }
  .filw{
    // padding: 0 23px;
    .infor{
      color: #999999;
      padding: 0 23px;
      padding-top: 8px;
    }
  }
  .fileList{
    border-bottom: 0px!important;
    display: flex;
    justify-content: space-between;
    background: #F4F6F9;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    .fileLink-left{
      display: flex;
      align-items: center;
    }
  }
  .syetem{
    border-bottom: 0px!important;
    .van-checkbox{
      margin-right:26px;
      margin-bottom: 13px;
    }
  }
  .remark{
    border-bottom: 0px!important;
  }
  .wrapper{
    margin-top: 20px;
    padding: 0 18px;
  }
</style>
<style lang="scss">
  .form-content {
    .van-picker__toolbar {
      background: #f9fafc !important;

      .van-picker__confirm {
        color: #2f7bff;
        font-size: 15px;
      }
    }

    .van-ellipsis.van-picker__title {
      font-size: 15px;
      color: rgba(0, 0, 0, .65);
    }

    .van-picker__cancel,
    .van-picker__confirm {
      line-height: 1;
    }

    .to-index {
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 80px;
    }
  }
  .show-box{
    color:#2F7BFF;
    font-size: 15px;
  }
  .active{
    height: 100px;
    background: #fff;
    overflow: hidden;
  }
  .actives{
    height: auto;
  }
  .h12{
    height: 12px;
  }
  .fileList{
    .van-button--default{
      background: transparent;
      border: none;
    }
    .van-uploader{
      width: 100%;
    }
    .van-uploader__preview{
      display: none;
    }
    .van-uploader__wrapper{
      width: 100%;
    }
    .van-uploader__input-wrapper{
       width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/oneclickSubmit.vue